import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';

const ConfirmRemoveLanguageDialog = () => {
  const dispatch = useAppDispatch();
  const opened =
    useSelector(
      (state: Store) => state.dialog[DIALOGS.confirmRemoveLanguageDialog]?.opened || false,
    );
  const callback =
    useSelector(
      (state: Store) => state.dialog[DIALOGS.confirmRemoveLanguageDialog]?.payload || null,
    );

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.confirmRemoveLanguageDialog }));
  };

  const handleOk = () => {
    callback();
    dispatch(closeDialog({ dialog: DIALOGS.confirmRemoveLanguageDialog }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="confirm-payment"
      open={opened}>
      <DialogTitle id="confirm-remove-language">Confirm</DialogTitle>
      <DialogContent dividers>
        Are you sure you want to remove this language?
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'menus.yes_proceed')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmRemoveLanguageDialog;
